module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_3@2x-6386f4fd8a151b674d2707b826a15cf7.jpg";